module.exports = __webpack_public_path__ + "img/pic_keqi@2x.67cba5d8.png";